import Panel from '../Panel';
import ImageBlock from '../ImageBlock';
import {ImageSize} from '../../enums/ImageSize';
import {useSettingsContext} from '../../context/settings/useSettingsContext';
import {IOnlineCondolenceDetails} from '../../types/resources/OnlineCondolenceDetails';
import FuneralDirectorInfo from './FuneralDirectorInfo';
import styled from 'styled-components';

const StyledPanel = styled(Panel)`
    @media (max-width: 480px) {
      && {
        align-items: center;
        flex-direction: column;
        text-align: center;
      }
    }
`;

type TProps = {
    details: IOnlineCondolenceDetails;
}

const FuneralDirectorListItem = ({details}: TProps) => {
    const { publicUrl } = useSettingsContext();

    return (
        <StyledPanel className={'cr-funeral-director cr-bg-grey-medium cr-gap'}>
            <div>
                <ImageBlock
                    src={details.assignedToImageUrl ?? `${publicUrl}/placeholder-funeral-director.jpg`}
                    placeholderSrc={`${publicUrl}/placeholder-funeral-director.jpg`}
                    alt={details.assignedToDisplayName ?? ''}
                    size={ImageSize.Small}
                />
            </div>
            <div className="cr-flex cr-flex-col cr-justify-evenly cr-w-100">
                <FuneralDirectorInfo details={details}/>
            </div>
        </StyledPanel>
    )
}

export default FuneralDirectorListItem;
